import { render } from "./Habit.vue?vue&type=template&id=abab2022&scoped=true"
import script from "./Habit.vue?vue&type=script&lang=js"
export * from "./Habit.vue?vue&type=script&lang=js"

import "./Habit.vue?vue&type=style&index=0&id=abab2022&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abab2022"]])

export default __exports__